import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

export default function PHLProduct() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable title="Product Content" name="ProductContent" />
        </Container>
      </div>
    </React.Fragment>
  );
}
